import { clearToken } from "./clear-token"

export const signout = async () => {
    clearToken()
    window.location.reload()
}
